import React from 'react'
import { FOCUS_RING } from '../utils/a11y'
import backgroundImage from '../../assets/background_team.webp'
import icMore from '../../assets/icon/ic_more.webp'
import icEdit from '../../assets/icon/ic_edit.webp'
import icRecord from '../../assets/icon/ic_voice.webp'
import icAttachment from '../../assets/icon/ic_attachment.webp'
import profileGrasisun from '../../assets/profile/profile_gravisun.webp'
import profileAmin from '../../assets/profile/profile_amin.webp'
import profileAlex from '../../assets/profile/profile_alexandra.webp'
import profileHans from '../../assets/profile/profile_hans.webp'
import chatMessageImage from '../../assets/chat_picture.webp'
import { useMediaQuery } from '../hooks/useMediaQuery';

export default function SectionTeam(props) {
    /* One shared media-query listener, and no measurement at all.
     *
     * The old resize effect depended on `props` — an object whose identity
     * changes on EVERY parent render — so it removed and re-added a window
     * listener continuously while the page scrolled (Home re-renders on each
     * section-theme change). It also derived the chat panel's height and the
     * heading's top margin from JS-measured viewport values, which the
     * prerender pass baked into the HTML as desktop pixels for every device. */
    const isSmallScreen = !useMediaQuery("(min-width: 1280px)", true);

    return (
        <section id="team" ref={props.sectionRef} className="flex nav-sm:min-h-[100svh] section7 bg-no-repeat bg-cover" style={{ backgroundImage: `url(${backgroundImage})` }} >
            <div className='flex-1 flex flex-col items-center'>
                <h2 data-reveal className='text-36 c-lg:text-48 c-xl:text-60 text-white font-bold mt-[52px] c-md:mt-[56px] c-lg:mt-[90px] c-xl:mt-[125px]'>TEAM</h2>
                <div className='w-full h-full flex items-center justify-center'>
                    <div data-reveal style={{ "--reveal-delay": "120ms" }} className='flex w-full md:w-4/5 c-lg:w-4/5 c-xl:w-3/5 max-h-[clamp(42.1875rem,68svh,57.375rem)] mb-12 mt-[40px] overflow-hidden justify-center'>
                        <div id="section-contact" aria-hidden="true" className='w-[432px] hidden c-lg:flex flex-col chat-list-background bg-[#0000004d] pb-[8px] no-select'>
                            <div className='flex justify-between mt-[24px] w-full '>
                                <p className='text-white text-42 ml-[40px]'> Messages</p>
                                <div className='flex mr-[30px]'>
                                    <img src={icMore} alt="" width={240} height={240} className='size-[60px] mx-1' loading="lazy"/>
                                    <img src={icEdit} alt="" width={240} height={240} className='size-[60px] mx-1' loading="lazy"/>
                                </div>
                            </div>
                            {/* Search */}
                            <div className='px-[15px] mt-[22px]'>
                                <div className='flex items-center w-full h-[60px] chat-search-box rounded-[16px]'>
                                    <p className='text-white text-24 opacity-60 ml-[24px] my-[15px]'>Search</p>
                                </div>
                            </div>
                            {/* Users Grid */}
                            <div className='overflow-y-auto flex-grow scrollbar-hide w-[432px] mt-[25px]' style={{ paddingBottom: '18px' }}>
                                <ContactsGrid />
                                <ContactChatHistoryList />
                            </div>
                        </div>
                        <div id="section-chat" className={`max-w-[690px] c-lg:max-w-[730px] ${(!isSmallScreen) ? 'section-chat-container' : 'section-chat-container-sm'} relative w-full md:bg-[#80808080] mx-6 md:mx-0`}>
                            <div className={`flex flex-col ${isSmallScreen ? 'chat-content-background-sm' : 'chat-content-background'} h-full w-full bg-[#80808080]`}>
                                <div className='overflow-hidden flex-grow scrollbar-hide px-[16px] md:px-[40px] flex flex-col justify-end pt-[10px] c-md:pt-0 '>
                                    <div className='flex flex-col-reverse overflow-y-auto scrollbar-hide '>
                                        <ChatBubble key={"3"} message={"Great Team! My name is Hans, I’m the engine of the development. Nice to meet you!"} profilePic={profileHans} />
                                        <ChatBubble key={"2"} message={"What a title!👏🏼 Hi everyone, I’m Alexa Visual & Design Director. If is comes to UI/UX I’m here to help!"} profilePic={profileAlex} />
                                        <ChatBubble key={"1"} message={"Hi! 👋 I'm Amin, the founder of Gravisun! We're Glad to have you here."} profilePic={profileAmin} />
                                        <img src={chatMessageImage} alt="" width={1784} height={1048} className='mb-[5px] nav-sm:mb-[4px] mt-[9px] nav-sm:mt-[44px] w-full md:w-4/5 pl-[68px] nav-sm:pl-[80px]' loading="lazy"/>
                                    </div>
                                </div>
                                <div className='flex items-center justify-start gap-x-4 w-full px-[16px] md:px-[40px] mt-[16px]'>
                                    <div className='flex items-center justify-center h-[50px] md:h-[50px] hidden c-lg:flex bg-colorWhite10 text-white rounded-[32px] px-[32px]'>
                                        <p className='text-18 nav-sm:text-24'>Love it!</p>
                                    </div>
                                    <div className='flex items-center justify-center h-[50px] md:h-[50px] hidden c-lg:flex bg-colorWhite10 text-white rounded-[32px] px-[32px]'>
                                        <p className='text-18 nav-sm:text-24'>I’m in.</p>
                                    </div>
                                    <button type='button' aria-haspopup='dialog'
                                        className={`flex items-center justify-center h-[50px] md:h-[50px] text-white join-button cursor-pointer px-[32px] ${FOCUS_RING}`}
                                        onClick={props.toggleJoinPopup}>
                                        <span className='z-10 text-18 nav-sm:text-24'>Join the team</span>
                                    </button>
                                </div>
                                <div className='flex items-center px-[16px] md:px-[40px] mb-[24px] mt-[24px]'>
                                    <img src={icAttachment} alt="" width={240} height={241} className='size-[55px] md:size-[60px]' loading="lazy"/>
                                    <div className='pl-3 w-full'>
                                        <div className='flex justify-between items-center w-full h-[55px] md:h-[60px] chat-search-box rounded-[30px]'>
                                            <p className='text-14 sm:text-18 c-2lg:text-22 pl-[12px] m12p:pl-[24px] text-white opacity-60'>{(!isSmallScreen) ? "To apply, click on the “Join the team” button" : "Click the “Join the team” button"}</p>
                                            <img src={icRecord} alt="" width={192} height={193} className='size-[42px] md:size-[48px] mr-[6px]' loading="lazy"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

function ContactsGrid() {
    return (
        <div className="grid grid-cols-3 mx-[20px] ">
            <ContactItem name={"Gravisun"} img={profileGrasisun} isSelected={true} />
            <ContactItem name={"Amin"} img={profileAmin} />
            <ContactItem name={"Alexa"} img={profileAlex} />
            <ContactItem name={"Hans"} img={profileHans} />
        </div>
    )
}

function ContactItem(props) {
    return (
        <div className={` ${props.isSelected ? 'chat-profile-selected' : ''} flex flex-col items-center justify-center h-[164px] w-[130px]`}>
            <img src={props.img} alt="" width={400} height={400} className='h-[100px] w-[100px]' loading="lazy"/>
            <p className='text-white text-20 opacity-60 mt-1'>{props.name}</p>
        </div>
    )
}

function ChatBubble({ message, profilePic }) {
    return (
        <div className="flex items-end my-[8px] nav-sm:my-[15px] w-full md:w-4/5">
            <img src={profilePic} alt="" width={400} height={400} className="w-[57px] h-[57px] nav-sm:w-[64px] nav-sm:h-[64px] rounded-full" loading="lazy"/>
            <div className="bg-colorWhite30 text-white p-[16px] rounded-[20px] relative ml-[11px] nav-sm:ml-[16px]">
                <div className="overflow-hidden relative">
                    <p className='text-14 c-md:text-18 nav-sm:text-22 opacity-[0.8] leading-[28px]'>{message}</p>
                </div>
            </div>
        </div>
    );
};

function ContactChatHistoryList() {
    return (
        <div className='flex flex-col mt-[10px]'>
            <ContactChatHistoryItem
                name={"Amin"}
                message={"Hey! Just a reminder that we are launching a new project and need you on the board! 😄"}
                profilePic={profileAmin}
                lastItem={true}
                time={"11:00 AM"} />
            <ContactChatHistoryItem
                name={"Alexa"}
                message={"Hey! How are you feeling today? Can’t wait to meet w/ our new client!"}
                profilePic={profileAlex}
                lastItem={false}
                time={"10:12 AM"} />
            <ContactChatHistoryItem
                name={"Hans"}
                message={"Morning! Check out how smooth the app runs after all the optimizations!"}
                profilePic={profileHans}
                lastItem={true}
                time={"9:04 AM"} />
        </div>
    )
}

function ContactChatHistoryItem({ name, message, profilePic, time, lastItem }) {
    return (
        <div className={`flex w-full px-[40px] mt-[15px] ${(lastItem === false) ? 'mb-[15px]' : 'mb-0'}`}>
            <img src={profilePic} alt="" width={400} height={400} className="w-[64px] h-[64px] rounded-full mt-3" loading="lazy"/>
            <div className="text-white rounded-lg relative ml-[12px]">
                <div className='flex justify-between'>
                    <p className='text-white text-24 leading-[28px]'>{name}</p>
                    <p className='text-colorWhite60 text-18 leading-[25px]'>{time}</p>
                </div>
                <div className="overflow-hidden relative">
                    <p className='text-md text-colorWhite60 text-18 leading-[25px] mt-[4px]'>{message}</p>
                </div>
            </div>
        </div>
    )
}